import { useEffect, useState } from "react";

const dict = {
  de: {
    app_title: "Helix App",
    app_sub: "User/Mandanten & Admin",
    tabs_analyse: "LPR",
    tabs_analyse_sub: "LPR", 
    tabs_status: "Status",
    tabs_audit: "Audit",
    tabs_dashboard: "Dashboard",
    tabs_settings: "Einstellungen",
    tabs_help: "Hilfe",
    
    // Alarm
    alarm_label: "Alarm ein",
    alarm_off_label: "Alarm aus",
    alarm_armed: "Alarm: Scharf",
    alarm_disarmed: "Alarm: Unscharf",
    
    status_dashboard_title: "System Status",
    status_dashboard_subtitle: "Systemübersicht und Status-Informationen",
    status_system_online: "System Online",
    status_system_online_desc: "Alle Services laufen normal",
    status_verkada_api: "Verkada API",
    status_verkada_connected: "Verbunden",
    status_verkada_not_configured: "Nicht konfiguriert",
    status_cameras_title: "Kamera-Übersicht",
    status_cameras_refresh: "Aktualisieren",
    status_cameras_loading: "Lädt...",
    status_cameras_api_key_required: "API-Schlüssel erforderlich. Bitte in den Einstellungen konfigurieren.",
    status_cameras_none_loaded: "Keine Kameras geladen. Klicken Sie auf \"Aktualisieren\".",
    status_cameras_found: "Kameras gefunden",
    status_camera_location: "Standort",
    status_camera_not_specified: "Nicht angegeben",
    status_camera_firmware: "Firmware",
    status_camera_firmware_current: "aktuell",
    status_camera_firmware_outdated: "veraltet",
    audit_title: "Audit Logs",
    audit_subtitle: "Verkada Audit Logs und Aktivitätsprotokolle",
    audit_time_range: "Zeitraum",
    audit_last_24h: "Letzte 24 Stunden", 
    audit_last_7d: "Letzte 7 Tage",
    audit_last_30d: "Letzte 30 Tage",
    audit_custom: "Benutzerdefiniert",
    audit_loading: "Lädt Audit Logs...",
    audit_error: "Fehler beim Laden der Audit Logs",
    audit_no_data: "Keine Audit Logs im gewählten Zeitraum gefunden",
    audit_refresh: "Aktualisieren",
    audit_page_size: "Einträge pro Seite",
    audit_timestamp: "Zeitstempel",
    audit_action: "Aktion",
    audit_user: "Benutzer",
    audit_details: "Details",
    audit_event: "Ereignis",
    audit_device: "Gerät",
    audit_ip_address: "IP-Adresse",
    audit_no_actions: "Keine Aktionen",
    audit_no_payload: "Keine Payload-Daten",
    audit_hours_ago: "vor {h}h",
    audit_logs: "Audit Logs",
    audit_custom_days: "Benutzerdefiniert ({} Tage)",
    audit_days_slider: "Tage: {} (bis max 30)",
    audit_day: "Tag",
    audit_days: "Tage",
    audit_time_range_label: "Zeitraum",
    audit_slider_hint: "Ziehen Sie den Regler und lassen Sie los, um die Audit Logs zu laden",
    audit_select_all: "Alle auswählen",
    audit_selected_count: "{} ausgewählt",
    audit_bulk_actions: "Aktionen für Auswahl",
    audit_export_selected: "Ausgewählte exportieren",
    audit_clear_selection: "Auswahl löschen",
    entries: "Einträge",
    tabs_help: "Hilfe",
    show_password: "anzeigen",
    hide_password: "verbergen",
    show_details: "Details anzeigen",
    fields: "Felder",
    data_loading: "Daten werden geladen...",
    load_statistics: "Statistik laden",
    click_load_sightings: "Klicken Sie auf \"Sichtungen laden\"",
    click_delta_calculate: "Klicken Sie auf \"Delta berechnen\" um zu starten",
    click_refresh_audit: "Klicken Sie auf \"Aktualisieren\", um Audit Logs zu laden",
    all_systems_ready: "Alle Systeme betriebsbereit",
    no_cameras_loaded: "Keine Kameras geladen",
    login_user_title: "E‑Mail (User/Mandant)",
    login_password: "Passwort",
    login_user_btn: "User/Mandanten‑Login",
    api_key_available: "API-Key verfügbar",
    api_key_missing: "API-Key fehlt",
    more_available: "weitere verfügbar",
    login_hint: "Mit E‑Mail/Passwort anmelden. LPR steht nur User/Mandant zur Verfügung.",
    login_please_wait: "Bitte warten…",
    login_admin_toggle_show: "Admin‑Login anzeigen",
    login_admin_toggle_hide: "Admin‑Login verbergen",
    login_admin_email: "Admin E‑Mail",
    login_admin_btn: "Admin‑Login",
    date_pick: "Datum wählen",
    date_pick_hint: "Wählen Sie ein Datum aus",
    date_selected: "Ausgewählt:",
    configuration: "Konfiguration",
    configuration_hint: "Parameter für die Analyse festlegen",
    threshold: "Schwelle (0–48 Std.)",
    gap: "Dedup‑Gap (0–30 Min.)",
    camera_ids: "Camera Device IDs",
    plate_filter: "Kennzeichen‑Filter",
    delta_calc: "Delta berechnen",
    csv_download: "CSV Download",
    user_settings: "Benutzer‑Einstellungen",
    settings_title: "Benutzer‑Einstellungen",
    settings_saved: "Gespeichert",
    settings_cameras_title: "Kamera-IDs",
    x_api_key_new: "Neuer x-api-key (optional, wird gespeichert)",
    x_api_key_saved_note: "Ein API‑Key ist bereits gespeichert. Neues Einfügen überschreibt.",
    org_id: "Org ID",
    org_id_placeholder: "z.B. ac6b3acd-347d-4fc7-bc91-...",
    org_id_saved: "Gespeichert:",
    region: "Region (us | eu | au)",
    timezone: "Zeitzone",
    camera_replace: "Kamera-IDs (ersetzen die hinterlegte Liste)",
    positives_title: "Positive Kennzeichen (werden bei Delta ignoriert)",
    positives_add: "Hinzufügen",
    positives_delete: "Löschen",
    settings_save: "Einstellungen speichern",
    delta_pairs: "Delta‑Paare",
    sightings: "Roh‑Sichtungen",
    load_sightings: "Rohsichtungen laden",
    loading: "Lädt...",
    sightings_csv: "Rohdaten CSV",
    entries: "Einträge",
    vip_plates: "VIP-Kennzeichen",
    vip_plates_highlighted: "VIP-Kennzeichen hervorgehoben",
    plate_placeholder: "z.B. PAMX",
    plate_input_placeholder: "Kennzeichen (z.B. ABC123)",
    loading_webhook_config: "Lädt Webhook-Konfiguration...",
    webhook_token_placeholder: "z.B. mein-verkada-hook-2024",
    item_placeholder: "z.B. Kaffee, Sandwich, etc.",
    hint_admin_no_lpr: "Hinweis: Admin kann keine LPR‑Abfragen durchführen; nur Nutzerverwaltung.",
    hint_select_entries: "Hinweis: Wählen Sie Einträge aus, um sie zu exportieren",
    export_entries: "Einträge exportieren",
    please_select_entries: "Bitte wählen Sie zuerst Einträge aus",
    load_more_entries: "Weitere Einträge laden",
    th_plate: "Kennzeichen",
    th_entry: "Eintritt",
    th_exit: "Austritt",
    th_dur_min: "Dauer (Min)",
    th_dur_h: "Dauer (Std)",
    th_cam_entry: "Eintritt‑Cam",
    th_cam_exit: "Austritt‑Cam",
    th_image: "Bild",
    empty_delta: "Keine Delta‑Daten für Filter/Datum. Bitte Parameter anpassen.",
    empty_sight: "Noch keine Roh‑Sichtungen geladen.",
    help_title: "Hilfe & Legende",
    help_text: "Grün: unter Schwelle · Gelb: nahe dran · Rot: deutlich drüber. Gap: Zusammenfassung kurz aufeinander folgender Sichtungen.",
    help_login_title: "🔐 Login & Benutzerrollen",
    help_login_text: "• User/Mandanten-Login: Vollzugriff auf LPR-Analyse und Einstellungen\n• Admin-Login: Nur Benutzerverwaltung, kein LPR-Zugriff\n• Ein User pro Mandant kann sich einloggen",
    help_analysis_title: "📊 LPR Analyse",
    help_analysis_sightings: "🔍 Sichtungen (Rohdaten):\n• Alle Kennzeichen-Erkennungen eines Tages\n• Filter: Kennzeichen-Suche, Kamera-Auswahl\n• Rote Markierung: VIP-Kennzeichen\n• 📊 Automatische Stundenstatistik nach dem Laden",
    help_analysis_delta: "⏱️ Delta Analyse:\n• Zeigt Aufenthaltsdauer von Kennzeichen\n• Schwellwert: Mindest-Aufenthaltsdauer in Stunden\n• Gap: Zusammenfassung naher Sichtungen\n• Farbcode: Grün (kurz) → Gelb → Rot (lang)",
    help_sightings_chart_title: "📊 Sichtungen pro Stunde",
    help_sightings_chart_text: "Zeigt automatisch eine Grafik mit der Verteilung der Fahrzeugerkennungen über 24 Stunden:\n• Lädt automatisch nach Rohsichtungen\n• Balkendiagramm: Anzahl Sichtungen pro Stunde\n• Datum im Format: DD-MM-YY\n• Interaktive Tooltips mit Details",
    help_status_title: "📈 Status Dashboard", 
    help_status_system: "🟢 System Online: Zeigt den aktuellen Status aller Services\n📡 Verkada API: Verbindungsstatus zur Verkada-Plattform\n📹 Kamera-Übersicht: Live-Thumbnails und Details aller Kameras",
    help_status_cameras: "Kamera-Funktionen:\n• Automatisches Laden beim Dashboard-Aufruf\n• Live-Thumbnails von jeder Kamera\n• Status-Anzeige: Live (grün) / Offline (rot)\n• Firmware-Status: 🟢 aktuell / 🔴 veraltet\n• Detaillierte Informationen: Standort, IP, Serial, Features",
    help_audit_title: "🔍 Audit Logs",
    help_audit_overview: "Überwachen Sie alle Systemaktivitäten und Benutzeraktionen in Echtzeit:",
    help_audit_timerange: "⏰ Zeitraum-Auswahl:\n• 24h, 7d, 30d - Vordefinierte Bereiche\n• Benutzerdefiniert: Slider für 1-30 Tage\n• Ziehen und loslassen zum Laden",
    help_audit_table: "📊 Tabellen-Funktionen:\n• Sortierung: Klick auf Spaltenüberschrift\n• 🏷️ Sort nach Art: Gruppierung nach Event-Typ\n• Checkboxes: Multi-Select für Export\n• Hover-Effekte: Verbesserte Navigation",
    help_audit_columns: "📋 Spalten-Details:\n• Zeitstempel: Deutsches Format mit 'vor Xh'\n• Benutzer: 👤 Badges mit Name/Email\n• Ereignis: Event-Beschreibung + IP-Adresse\n• Gerät: 🔧 Device Name + 📍 Site-Info",
    help_audit_actions: "⚡ Aktionen:\n• CSV-Export: Ausgewählte Einträge exportieren\n• Auswahl löschen: Selection zurücksetzen\n• Live-Aktualisierung mit Refresh-Button",
    help_settings_title: "⚙️ Einstellungen",
    help_settings_user: "👤 Benutzereinstellungen:\n• API-Schlüssel: Verkada-Zugang\n• Kameras: Auswahl der überwachten Kameras\n• Region & Zeitzone: Verkada-Server-Einstellungen",
    help_settings_positive: "✅ Positive Kennzeichen:\n• 'Whitelist' - diese werden aus Delta-Analyse ausgeblendet\n• Eingabe: Einzeln oder mehrere (Komma/Zeile getrennt)",
    help_vip_title: "🔴 VIP Kennzeichen (LPOI)",
    help_vip_text: "VIP Kennzeichen werden in den Rohdaten ROT markiert und mit 🔴 gekennzeichnet.",
    help_vip_types: "🔗 Verkada LPOI: In Verkada gespeichert und synchronisiert\n📍 Lokal: Nur in dieser Anwendung gespeichert",
    help_vip_functions: "• Lokal hinzufügen: Speichert VIP nur in der App\n• Verkada erstellen: Erstellt LPOI direkt in Verkada\n• Verkada Sync: Ruft alle LPOIs von Verkada ab\n• Löschen: Entfernt VIP (bei Verkada auch aus Verkada)",
    help_admin_title: "👥 Admin-Funktionen",
    help_admin_text: "• Benutzer erstellen: E-Mail, Passwort, Rolle zuweisen\n• Benutzer löschen: Bestehende Benutzer entfernen\n• Rolle 'user': LPR-Zugriff + Einstellungen\n• Rolle 'admin': Nur Benutzerverwaltung",
    help_ai_analytics_title: "🧠 AI Analytics",
    help_ai_analytics_intro: "Analysieren Sie Kamerabilder mit KI (Google Gemini) und erstellen Sie automatisch Helix-Events in Verkada.",
    help_ai_analytics_setup: "1. Einrichtung:",
    help_ai_analytics_setup_desc: "• Gemini API-Key: Eigenen Google AI API-Key in den Einstellungen hinterlegen\n• Kamera ID: Die Verkada Kamera-ID für das Abrufen von Bildern\n• HELIX UID: Event-Typ-ID aus Verkada für die Helix-Integration\n• Org ID: Ihre Verkada Organisations-ID (globale Einstellung)",
    help_ai_analytics_usage: "2. Verwendung:",
    help_ai_analytics_usage_desc: "• 'Letztes Bild holen': Aktuelles Bild von der konfigurierten Kamera laden\n• 'Manueller Upload': Eigenes Bild hochladen (max. 1024px, automatisch komprimiert)\n• Instruktion eingeben: Frage an die KI (max. 200 Zeichen)\n• 'Analysieren': KI analysiert das Bild und gibt true/false/unknown zurück",
    help_ai_analytics_helix: "3. Helix-Integration:",
    help_ai_analytics_helix_desc: "• Bei Bildern von der API wird automatisch ein Helix-Event erstellt\n• Event enthält: Ergebnis (true/false), Frage, Zeitstempel\n• Flagged-Status: true bei positivem Ergebnis\n• Nur bei konfigurierter HELIX UID und Org ID",
    help_ai_analytics_history: "4. Verlauf:",
    help_ai_analytics_history_desc: "• Die letzten 25 Analysen werden in einer Tabelle angezeigt\n• Enthält: Zeitstempel, Thumbnail, Instruktion, Ergebnis\n• Daten werden pro Benutzer gespeichert",
    help_tips_title: "💡 Tipps & Tricks",
    help_tips_text: "• Datum für Analyse auswählen\n• Gap-Minuten: Reduziert Mehrfacherkennungen\n• Offene Sessions: Fahrzeuge ohne Ausfahrt\n• VIP für wichtige/verdächtige Kennzeichen nutzen\n• 📊 Stundengrafik zeigt Verkehrsmuster automatisch\n• Grafik lädt automatisch nach Rohsichtungen",
    admin_console: "Admin‑Konsole: Nutzerverwaltung",
    admin_new_user: "Neuen Nutzer anlegen – E‑Mail",
    admin_password: "Passwort",
    admin_role: "Rolle",
    admin_create: "Nutzer anlegen",
    admin_refresh: "Liste aktualisieren",
    admin_users_title: "Angelegte Nutzer",
    admin_search: "Suchen",
    admin_pw_reset: "PW neu setzen",
    admin_delete: "Löschen",
    admin_delete_field: "Nutzer löschen – E‑Mail",
    admin_delete_btn: "Nutzer löschen",
    confirm_delete_user: "Nutzer wirklich löschen?",
    confirm_delete_plates: "Positive Kennzeichen wirklich löschen?",
    
    // Kassensystem
    kasse_title: "Kasse",
    kasse_subtitle: "Point-of-Sale System für Verkaufsabwicklung",
    kasse_add_item: "Artikel hinzufügen",
    kasse_item_name: "Artikel Name",
    kasse_item_price: "Preis (€)",
    kasse_item_quantity: "Anzahl",
    kasse_add_to_cart: "Artikel hinzufügen",
    kasse_quick_add: "Quick Add",
    kasse_customer_name: "Kunde (optional)",
    kasse_total_amount: "Gesamtsumme",
    kasse_complete_payment: "Zahlung abschließen",
    kasse_process_return: "Rücknahme",
    kasse_clear_cart: "Rechnung löschen",
    kasse_cart: "Warenkorb",
    kasse_empty_cart: "Noch keine Artikel hinzugefügt",
    kasse_empty_cart_desc: "Fügen Sie oben Artikel hinzu, um zu beginnen",
    kasse_item_article: "Artikel",
    kasse_item_quantity_short: "Anzahl",
    kasse_item_unit_price: "Einzelpreis",
    kasse_item_total_price: "Gesamt",
    kasse_action: "Aktion",
    
    // Kassensystem Historie
    kasse_history_title: "Transaktionshistorie",
    kasse_history_subtitle: "Letzte 50 Kassen-Transaktionen",
    kasse_search_placeholder: "🔍 Suche nach Kunde oder Artikel...",
    kasse_search_no_results: "Keine Ergebnisse gefunden",
    kasse_table_datetime: "Datum & Uhrzeit",
    kasse_table_items: "Artikel",
    kasse_table_customer: "Kunde",
    kasse_table_thumbnail: "Kamera-Aufnahme",
    kasse_table_empty: "Noch keine Transaktionen",
    
    // Kassenbon Modal
    receipt_title: "Kassenbon",
    receipt_store_name: "Helix Cafe Shop",
    receipt_store_address: "Industriestraße 42, 10115 Berlin",
    receipt_date: "Datum",
    receipt_time: "Uhrzeit",
    receipt_receipt_no: "Beleg-Nr",
    receipt_customer: "Kunde",
    receipt_items_title: "Artikel",
    receipt_quantity: "Anz.",
    receipt_price_each: "Einzelpreis",
    receipt_price_total: "Gesamt",
    receipt_subtotal: "Zwischensumme",
    receipt_tax: "inkl. MwSt. (19%)",
    receipt_total: "SUMME",
    receipt_payment_method: "Zahlungsart",
    receipt_payment_cash: "Bar",
    receipt_thank_you: "Vielen Dank für Ihren Einkauf!",
    receipt_return: "RÜCKNAHME",
    receipt_refund: "Erstattung",
    receipt_snapshot: "Kamera-Aufnahme",
    
    // Kassensystem Hilfe
    help_kasse_title: "💰 Kassensystem",
    help_kasse_intro: "Point-of-Sale System mit Verkada-Integration für Verkäufe und Rücknahmen.",
    help_kasse_add_items: "🛒 Artikel hinzufügen:",
    help_kasse_add_items_desc: "• Quick Add: ☕ Caffee (€3,00), 🥪 Sandwich (€5,00), 🥤 Drink (€2,00)\n• Manuell: Name, Preis, Anzahl eingeben",
    help_kasse_transactions: "💳 Verkäufe & ↩️ Rücknahmen:",
    help_kasse_transactions_desc: "• \"Zahlung abschließen\" → Verkada Event (flagged: false)\n• \"Rücknahme\" → Verkada Event (flagged: true)\n• Automatische Berlin-Zeit und Video Tagging",
    help_kasse_settings: "⚙️ Einstellungen erforderlich:",
    help_kasse_settings_desc: "• UID (Verkada Helix) + Kamera-ID Kasse\n• API-Schlüssel mit Video Tagging Berechtigung",
    
    help_shipping_title: "📦 Versandlabel System",
    help_shipping_intro: "Automatisiertes Versandlabel-System mit Verkada-Integration für Paketerfassung, Tracking und Kamera-Aufnahmen.",
    help_shipping_label: "🏷️ Label erstellen:",
    help_shipping_label_desc: "• Tracking-Nummer: Automatisch generiert beim Öffnen\n• 🌍 Generiere Adresse: 41 internationale Fake-Adressen\n• 📦 Generiere Inhalt: 50 elektronische Geräte (1-5 zufällig)\n• Versandadresse: Vollständige Lieferadresse eingeben\n• Paketinhalt: Kurze Beschreibung des Inhalts\n• UPS-Style Label mit allen Details",
    help_shipping_workflow: "📋 Workflow:",
    help_shipping_workflow_desc: "• Modul öffnen → Tracking-Nr wird generiert\n• Adresse & Inhalt eingeben (oder generieren)\n• \"Label erstellen\" → Verkada Event wird gesendet\n• Nach 3 Sekunden: Kamera-Thumbnail wird automatisch geholt\n• Bei Erfolg: Neue Tracking-Nr für nächstes Label\n• Bei Fehler: Daten bleiben für erneuten Versuch",
    help_shipping_verkada: "🔗 Verkada Integration:",
    help_shipping_verkada_desc: "• Sendet Event mit Attributen: Tracking, Adresse, Position\n• Video Tagging mit konfigurierbarer Kamera\n• Automatische Zeiterfassung (Epoch Timestamp)\n• Thumbnail wird 3 Sek. nach Event geholt (low-res)\n• Erfolgsbestätigung oder Fehlermeldung",
    help_shipping_settings: "⚙️ Einstellungen erforderlich:",
    help_shipping_settings_desc: "• UID (Verkada Helix) für Versandmodul\n• Kamera-ID für Versandbereich (für Thumbnails)\n• API-Schlüssel mit Video Tagging & View Footage Berechtigung\n• Region: EU oder US Server",
    help_shipping_features: "✨ Features:",
    help_shipping_features_desc: "• Automatische Tracking-Nummern (1Z + 16 Zeichen)\n• UPS-kompatibles Label-Design\n• 📸 Kamera-Thumbnails (klickbar für Vollbild)\n• Text-Kürzung auf max. 200 Zeichen pro Feld\n• Erfolg/Fehler-Meldungen wie Kassenmodul\n• Felder werden automatisch geleert nach Erfolg",
    help_shipping_history: "📋 Versandhistorie:",
    help_shipping_history_desc: "• Zeigt letzte 50 erstellte Labels\n• 🔍 Durchsuchbar: Tracking-ID, Adresse, Inhalt\n• ↕️ Sortierbar: Nach Datum, Tracking, Adresse, Inhalt\n• Spalten: Datum/Zeit, Tracking-ID, Adresse, Inhalt, Thumbnail\n• Thumbnails klickbar für vergrößerte Ansicht",
    
    // Automation Help
    help_automation_title: "Automation",
    help_automation_intro: "Steuern Sie Ihre Shelly-Geräte direkt aus dem Dashboard.",
    help_automation_setup: "⚙️ Einrichtung:",
    help_automation_setup_desc: "1. Gehen Sie zu Einstellungen → Shelly\n2. Tragen Sie Ihren Shelly Server ein (z.B. https://shelly-XX-eu.shelly.cloud)\n3. Fügen Sie Ihren Auth Key aus der Shelly Cloud App hinzu\n4. Tragen Sie die Geräte-IDs und Namen ein",
    help_automation_control: "🎮 Steuerung:",
    help_automation_control_desc: "• Ein/Aus-Buttons zum direkten Schalten\n• Status wird automatisch beim Öffnen abgefragt\n• Aktualisieren-Button für manuelles Refresh\n• Stromverbrauch wird angezeigt (falls unterstützt)",
    help_automation_status: "📊 Status-Anzeige:",
    help_automation_status_desc: "Der farbige Punkt zeigt den aktuellen Gerätestatus an.",
    help_automation_colors: "Farblegende:",
    help_automation_color_on: "Eingeschaltet",
    help_automation_color_off: "Ausgeschaltet",
    help_automation_color_offline: "Offline",
    help_automation_color_loading: "Laden...",
    
    // Menu Dropdown
    menu_webhooks: "Webhooks",
    menu_shipping: "Versand",
    menu_cash_register: "Kasse",
    
    // Dashboard
    dashboard_title: "🏠 Helix Control Center",
    dashboard_welcome: "Willkommen zurück",
    dashboard_time_suffix: "Uhr",
    dashboard_module_lpr_title: "LPR Analytics",
    dashboard_module_lpr_desc: "Kennzeichenerkennung\nEchtzeit-Analyse & Überwachung",
    dashboard_module_lpr_btn: "📊 Analyse starten",
    dashboard_module_status_title: "Status Dashboard", 
    dashboard_module_status_desc: "System-Überwachung\nLive-Status & Health Check",
    dashboard_module_status_btn: "📈 Status prüfen",
    dashboard_module_audit_title: "Audit Dashboard",
    dashboard_module_audit_desc: "Sicherheit & Aktivitätslogs\nAnzeigen, Suchen & Exportieren", 
    dashboard_module_audit_btn: "🔍 Audit öffnen",
    dashboard_module_kasse_title: "Kassensystem",
    dashboard_module_kasse_desc: "Point of Sale System\nVerkada Integration & Events",
    dashboard_module_kasse_btn: "💰 Kasse öffnen",
    dashboard_module_settings_title: "Einstellungen",
    dashboard_module_settings_desc: "Konfiguration & Setup\nAPI-Schlüssel, Kameras & VIPs",
    dashboard_module_settings_btn: "⚙️ Konfiguration",
    dashboard_module_webhook_title: "Webhook System",
    dashboard_module_webhook_desc: "Real-time Events\nVerkada Integration & Automatisierung",
    dashboard_module_webhook_btn: "🔗 Webhooks öffnen",
    dashboard_module_shipping_title: "Versandlabel System",
    dashboard_module_shipping_desc: "Versandlabel Verwaltung\nVerkada Integration & Paketerfassung",
    dashboard_module_shipping_btn: "📦 Versandlabel öffnen",
    dashboard_module_support_title: "AI Support",
    dashboard_module_support_subtitle: "Hilfe und Unterstützung",
    dashboard_module_support_desc: "",
    dashboard_module_support_btn: "🎧 Support öffnen",
    
    // Automation Module
    menu_automation: "Automation",
    automation_title: "Automation",
    automation_subtitle: "Geräte & Automatisierungen verwalten",
    automation_not_configured: "Shelly nicht konfiguriert",
    automation_not_configured_hint: "Bitte konfigurieren Sie Ihre Shelly-Geräte in den Einstellungen.",
    automation_no_devices: "Keine Geräte konfiguriert",
    automation_no_devices_hint: "Fügen Sie Shelly-Geräte in den Einstellungen hinzu.",
    automation_device: "Gerät",
    automation_device_single: "Gerät",
    automation_device_plural: "Geräte",
    automation_on: "Ein",
    automation_off: "Aus",
    automation_connected: "Verbunden",
    automation_not_connected: "Nicht konfiguriert",
    automation_offline: "Offline",
    automation_loading: "Laden...",
    automation_refresh: "Aktualisieren",
    automation_rules_title: "Automatisierungen",
    automation_rules_new: "Neu",
    automation_rules_coming_soon: "Automatisierungen werden in einem zukünftigen Update verfügbar sein.",
    automation_rules_example: "z.B. \"Wenn Kennzeichen erkannt → Licht einschalten\"",
    automation_lpr_shelly_title: "Shelly Schalter 1 einschalten bei LPR",
    automation_lpr_shelly_desc: "Wenn Webhook \"door_lp_presented_accepted\" empfangen wird: erster Shelly-Schalter 10 Sek. ein, dann automatisch aus.",
    automation_lpr_rejected_shelly_title: "Shelly Schalter 2 einschalten bei LPR rejected",
    automation_lpr_rejected_shelly_desc: "Wenn Webhook \"door_lp_presented_rejected\" empfangen wird: zweiter Shelly-Schalter 10 Sek. ein, dann automatisch aus.",
    automation_lpr_shelly_warning: "Hinweis: Shelly Server, Auth Key und mindestens 1 Gerät müssen unter Einstellungen konfiguriert sein, damit diese Regel wirkt.",
    automation_missing_device: "Schalter {n} fehlt – bitte unter Einstellungen konfigurieren.",
    automation_disarmed_call_title: "Anruf wenn Alarm ausgeschaltet wird",
    automation_disarmed_call_desc: "Wenn Webhook \"disarmed\" empfangen wird: konfigurierte Telefonnummer wird angerufen und der Text in der gewählten Sprache vorgelesen (Twilio Voice).",
    automation_armed_call_title: "Anruf wenn Alarm eingeschaltet wird",
    automation_armed_call_desc: "Wenn Webhook \"alarm_site_state_changed\" mit event_type=\"armed\" empfangen wird: konfigurierte Telefonnummer wird angerufen und der Text in der gewählten Sprache vorgelesen.",
    automation_armed_call_text_placeholder: "z.B. Achtung, der Alarm wurde gerade eingeschaltet.",
    automation_disarmed_call_to_label: "Telefonnummer (E.164)",
    automation_disarmed_call_lang_label: "Sprache",
    automation_disarmed_call_text_label: "Vorgelesener Text",
    automation_disarmed_call_text_placeholder: "z.B. Achtung, der Alarm wurde gerade ausgeschaltet.",
    automation_call_test_btn: "Anruf testen",
    automation_call_test_missing: "Bitte Telefonnummer und Text eingeben.",
    automation_call_test_ok: "✅ Test-Anruf erfolgreich ausgelöst",
    automation_call_test_fail: "❌ Test-Anruf fehlgeschlagen",
    automation_twilio_missing: "Twilio Account SID, Auth Token und From-Nummer müssen in den Einstellungen hinterlegt sein.",
    settings_twilio_title: "Twilio Voice",
    settings_twilio_subtitle: "Zugangsdaten für ausgehende Sprachanrufe (TTS).",
    settings_twilio_from_number: "twilioPhoneNumber (ausgehende Nummer)",
    settings_twilio_from_hint: "Twilio-Nummer im E.164-Format, z.B. +4911111111111",
    settings_saved_short: "gespeichert",
    dashboard_module_automation_title: "Automation",
    dashboard_module_automation_desc: "Geräte steuern\n& automatisieren",
    dashboard_module_automation_btn: "⚡ Öffnen",
    
    // AI Analytics Module
    dashboard_module_ai_analytics_title: "AI Analytics",
    dashboard_module_ai_analytics_subtitle: "Bildanalyse mit KI",
    dashboard_module_ai_analytics_btn: "AI Analytics öffnen",
    ai_analytics_title: "AI Analytics",
    ai_analytics_subtitle: "Intelligente Bildanalyse",
    ai_analytics_get_last_image: "Letztes Bild holen",
    ai_analytics_manual_upload: "Manueller Upload",
    ai_analytics_instruction: "Instruktion Ja/Nein Antwort",
    ai_analytics_instruction_placeholder: "Geben Sie hier Ihre Anweisung für die KI-Analyse ein...",
    ai_analytics_result: "Ergebnis",
    ai_analytics_result_placeholder: "Das Analyseergebnis erscheint hier...",
    ai_analytics_image_preview: "Bildvorschau",
    ai_auto_refresh_label: "Auto-Refresh aktiv",
    ai_auto_refresh_minutes_unit: "Min.",
    ai_auto_refresh_preset_label: "Vordefinierte Analyse (Auto-Refresh)",
    ai_auto_refresh_preset_none: "Keine Analyse",
    ai_auto_refresh_preset_hint: "Wenn Auto-Refresh aktiv ist und eine Analyse ausgewählt: alle X Minuten Bild holen + Analyse ausführen.",
    ai_preset_cat: "Ist eine Katze zu sehen?",
    ai_preset_tree: "Ist ein Baum zu sehen?",
    ai_preset_snow: "Liegt Schnee?",
    ai_preset_sun: "Scheint die Sonne?",
    ai_analytics_no_image: "Kein Bild geladen",
    ai_analytics_analyze: "Analysieren",
    ai_analytics_analyzing: "Analysiere...",
    ai_analytics_history_title: "Transaktionshistorie (letzte 25)",
    ai_analytics_history_datetime: "Datum & Uhrzeit",
    ai_analytics_history_image: "Bild",
    ai_analytics_history_instruction: "Instruktion",
    ai_analytics_history_result: "Ergebnis",
    ai_analytics_history_empty: "Noch keine Transaktionen vorhanden",
    
    // AI Analytics Settings
    ai_analytics_settings_title: "AI Analytics Einstellungen",
    ai_analytics_camera_id: "Kamera ID",
    ai_analytics_camera_id_placeholder: "z.B. camera-123-abc",
    ai_analytics_camera_id_saved: "Gespeichert:",
    ai_analytics_gemini_key: "Gemini API-Key",
    ai_analytics_gemini_key_placeholder: "Geben Sie Ihren Gemini API-Key ein",
    ai_analytics_gemini_key_saved: "✓ API-Key gespeichert",
    ai_analytics_helix_uid: "HELIX UID",
    ai_analytics_helix_uid_placeholder: "z.B. helix-uid-123",
    ai_analytics_helix_uid_saved: "Gespeichert:",
    ai_analytics_org_id: "Org ID",
    ai_analytics_org_id_placeholder: "z.B. ac6b3acd-347d-4fc7-bc91-...",
    ai_analytics_org_id_saved: "Gespeichert:",
    ai_analytics_save: "AI Analytics speichern",
    ai_analytics_saved_success: "AI Analytics Einstellungen gespeichert",
    
    // Support Module
    support_title: "Support Center",
    support_subtitle: "Hilfe & Unterstützung",
    support_enabled: "Support-Modul aktiviert",
    support_contact_title: "Kontakt",
    support_contact_desc: "Bei Fragen oder Problemen wenden Sie sich an unser Support-Team.",
    support_email: "E-Mail",
    support_phone: "Telefon",
    support_hours: "Erreichbarkeit",
    support_hours_value: "Mo-Fr 9:00-17:00 Uhr",
    support_faq_title: "Häufige Fragen",
    support_docs_title: "Dokumentation",
    support_docs_desc: "Anleitungen und Hilfestellungen",
    
    // Admin - Support checkbox
    admin_support_enabled: "Support-Modul",
    
    // Help - Workflow Recommendation
    help_workflow_title: "📋 Workflow-Empfehlung:",
    help_workflow_steps: "1. Einstellungen konfigurieren (API-Schlüssel, Kameras)\n2. Positive Kennzeichen definieren (bekannte Fahrzeuge)\n3. VIP-Kennzeichen festlegen (Fahndung/Überwachung)\n4. Kassensystem konfigurieren (UID + Kamera-ID)\n5. Versandlabel-System konfigurieren (UID + Kamera-ID)\n6. Tägliche Delta-Analyse für Auffälligkeiten\n7. Rohdaten bei konkreten Verdachtsfällen prüfen",
    
    // Webhook System
    webhook_title: "Webhook-Verwaltung",
    webhook_subtitle: "Verkada Webhooks für Real-time Events",
    webhook_url_label: "Ihre Webhook-URL:",
    webhook_url_copy: "URL kopieren",
    webhook_url_copied: "URL kopiert!",
    webhook_enabled: "Webhook aktiviert",
    webhook_disabled: "Webhook deaktiviert", 
    webhook_toggle: "Webhook aktivieren/deaktivieren",
    webhook_stats_title: "Webhook-Statistiken",
    webhook_stats_total: "Gesamt Events",
    webhook_stats_today: "Events heute",
    webhook_stats_last: "Letztes Event",
    webhook_auto_actions: "Automatische Aktionen",
    webhook_auto_vip: "Auto-VIP bei Person of Interest",
    webhook_events_title: "Event-History",
    webhook_events_type: "Event-Typ",
    webhook_events_time: "Zeitstempel",
    webhook_events_notification_type: "Mitteilungstyp",
    webhook_events_actions: "Ausgeführte Aktionen",
    webhook_events_payload: "Payload",
    webhook_events_refresh: "Events aktualisieren",
    webhook_events_empty: "Keine Webhook-Events vorhanden",
    webhook_notifications_title: "Live-Benachrichtigungen",
    webhook_notification_new: "Neues Webhook-Event",
    webhook_create_token: "Webhook-Token konfigurieren",
    webhook_create_description: "Erstellen Sie einen eindeutigen Token für Ihre Webhook-URL. Dieser Token identifiziert alle eingehenden Webhooks als zu Ihrem Account gehörig.",
    webhook_token_label: "Webhook-Token (mindestens 6 Zeichen):",
    webhook_token_placeholder: "z.B. mein-verkada-hook-2024",
    webhook_create_btn: "Erstellen",
    webhook_creating: "Erstellt...",
    
    // Shipping System
    shipping_title: "Versandlabel System",
    shipping_subtitle: "Versandlabel Verwaltung - Verkada Integration",
    shipping_uid_label: "Versand UID",
    shipping_uid_placeholder: "Verkada Helix Endpoint UID eingeben",
    shipping_uid_placeholder_saved: "(gespeichert) – zum Ändern neue UID eingeben",
    shipping_camera_label: "Versand Kamera ID",
    shipping_camera_placeholder: "Verkada Kamera-ID für Versandbereich",
    shipping_camera_placeholder_saved: "(gespeichert) – zum Ändern neue ID eingeben",
    shipping_settings_help: "UID: Eindeutige Verkada Helix Endpoint für Versand\nKamera-ID: Verkada Kamera-ID zur Überwachung des Versandbereichs",
    shipping_address_label: "Versandadresse",
    shipping_content_label: "Paketinhalt",
    shipping_address_placeholder: "Max Mustermann\nMusterstraße 123\n12345 Berlin\nDeutschland",
    shipping_content_placeholder: "Paketinhalt beschreiben...",
    shipping_generate_btn: "📦 Label erstellen",
    shipping_create_section: "📋 Versandlabel erstellen",
    shipping_preview_section: "📦 Versandlabel Vorschau",
    shipping_generate_address_btn: "🌍 Generiere Adresse",
    shipping_generate_content_btn: "📦 Generiere Inhalt",
    shipping_history_title: "Versandhistorie",
    shipping_history_subtitle: "Letzte 50 erstellte Versandlabel",
    shipping_search_placeholder: "🔍 Suche nach Tracking-ID, Adresse oder Inhalt...",
    shipping_search_no_results: "Keine Ergebnisse gefunden",
    shipping_table_datetime: "Datum & Uhrzeit",
    shipping_table_tracking: "Tracking-ID",
    shipping_table_address: "Versandadresse",
    shipping_table_content: "Paketinhalt",
    shipping_table_thumbnail: "Kamera-Aufnahme",
    shipping_table_empty: "Noch keine Versandlabel erstellt",
    
    // Email Modal
    email_subject: "📧 Versand deiner Bestellung",
    email_from: "Von",
    email_to: "An",
    email_date: "Datum",
    email_greeting: "Hallo",
    email_body_text: "deine bestellten Artikel",
    email_body_tracking: "sind mit Tracking-Nr.",
    email_body_shipped: "soeben versandt worden.",
    email_thumbnail_caption: "📸 Aufnahme zum Zeitpunkt des Versands",
    email_closing: "Viele Grüße und viel Spaß!",
    email_footer_company: "Helix Shop GmbH",
    email_footer_address_line1: "Industriestraße 42",
    email_footer_address_line2: "10115 Berlin, Deutschland",
    email_footer_disclaimer: "Diese E-Mail wurde automatisch generiert. Bitte nicht direkt antworten.",

    // Settings - Shelly / VIP / Kasse (hardcoded → i18n)
    settings_vip_plates_title: "VIP Kennzeichen (Verkada LPOI)",
    settings_vip_plates_add: "VIP Kennzeichen hinzufügen",
    settings_vip_plates_local_only: "Nur in dieser Anwendung gespeichert",
    settings_vip_delete_confirm: "VIP Kennzeichen \"{plate}\" wirklich löschen?",
    settings_kasse_not_configured: "⚠️ Kassen-Integration noch nicht konfiguriert",
    settings_kasse_camera_id: "Kamera-ID Kasse",
    settings_kasse_endpoint_desc: "Eindeutige Verkada Helix Endpoint für Kasse",
    settings_camera_id_label: "Kamera-ID:",
    settings_shelly_server_label: "Shelly Server",
    settings_shelly_server_hint: "Format: shelly-XX-eu.shelly.cloud (aus Shelly App → User Settings → Authorization Cloud Key)",
    settings_shelly_device_id_placeholder: "Device-ID (Hex), z.B. 34987a6b1234",
    settings_shelly_device_name_placeholder: "z.B. Licht Büro",
    settings_shelly_authkey_label: "Auth Key",
    settings_shelly_authkey_saved: "✓ Auth Key gespeichert",
    settings_shelly_devices_title: "Shelly Geräte",
    settings_shelly_no_devices: "Noch keine Geräte angelegt.",
    settings_shelly_remove_saved: "Gerät entfernen (erst nach Speichern)",
    settings_shelly_remove_entry: "Eintrag entfernen",
    settings_shelly_add_device: "+ Gerät hinzufügen",
    settings_shelly_hint: "Geräte-ID und Name eingeben, dann unten \"Speichern\" klicken. Änderungen (Hinzufügen, Bearbeiten, Löschen) werden erst nach \"Speichern\" übernommen.",
    settings_saved_alert: "Benutzer‑Einstellungen gespeichert.",
    settings_no_changes_alert: "Keine Änderungen",

    // App.js hardcoded
    app_user_label: "Nutzer:",
    app_please_login: "Bitte einloggen",
    app_no_users: "Keine Nutzer gefunden.",

    // Help / Webhooks hardcoded labels
    help_vip_types_label: "VIP-Typen:",
    webhooks_integration_label: "💡 Webhook-Integration:",

    // Live View (Settings)
    settings_liveview_title: "Live View",
    settings_liveview_subtitle: "Verkada Live-View iFrames für die Kamera-Anzeige.",
    settings_liveview_entry_prefix: "Liveview",
    settings_liveview_name_label: "Name",
    settings_liveview_name_placeholder: "z.B. Garten Kamera",
    settings_liveview_embed_label: "Embedded Code",
    settings_liveview_embed_placeholder: "<iframe src=\"https://vauth.prod2.verkada.com/__v/…/embed/html/…/\" frameborder=\"0\" width=\"400\" height=\"300\"></iframe>",
    settings_liveview_no_entries: "Noch keine Live Views angelegt.",
    settings_liveview_add: "+ weiteres Live View hinzufügen",
    settings_liveview_remove_entry: "Eintrag entfernen",
    settings_liveview_remove_saved: "Live View entfernen (erst nach Speichern)",
    settings_liveview_hint: "Name und Embedded Code eingeben, dann unten \"Speichern\" klicken. Änderungen (Hinzufügen, Bearbeiten, Löschen) werden erst nach \"Speichern\" übernommen. Einträge ohne Name ODER ohne Embedded Code werden beim Speichern verworfen.",

    // Live View (Page + Menu + Dashboard tile)
    menu_live_view: "Live View",
    dashboard_module_live_view_title: "Live View",
    dashboard_module_live_view_desc: "Kameras live ansehen\niFrame-Kacheln aus den Einstellungen",
    dashboard_module_live_view_btn: "📺 Öffnen",
    live_view_title: "Live View",
    live_view_subtitle: "Kameras aus den Einstellungen",
    live_view_enlarge: "Vergrößern",
    live_view_reload: "Neu laden",
    live_view_close: "Schließen",
    live_view_empty_title: "Noch keine Live Views angelegt.",
    live_view_empty_hint: "Öffne Einstellungen → Live View, um deine erste Kamera hinzuzufügen.",
    live_view_empty_cta: "Zu den Einstellungen",
  },
  en: {
    app_title: "Helix App",
    app_sub: "Users & Admin",
    tabs_analyse: "LPR",
    tabs_analyse_sub: "LPR",
    tabs_status: "Status", 
    tabs_audit: "Audit",
    tabs_dashboard: "Dashboard",
    tabs_settings: "Settings",
    tabs_help: "Help",
    
    // Alarm
    alarm_label: "Alarm on",
    alarm_off_label: "Alarm off",
    alarm_armed: "Alarm: Armed",
    alarm_disarmed: "Alarm: Disarmed",
    
    status_dashboard_title: "System Status",
    status_dashboard_subtitle: "System overview and status information",
    status_system_online: "System Online",
    status_system_online_desc: "All services running normally",
    status_verkada_api: "Verkada API",
    status_verkada_connected: "Connected",
    status_verkada_not_configured: "Not configured",
    status_cameras_title: "Camera Overview",
    status_cameras_refresh: "Refresh",
    status_cameras_loading: "Loading...",
    status_cameras_api_key_required: "API key required. Please configure in settings.",
    status_cameras_none_loaded: "No cameras loaded. Click \"Refresh\".",
    status_cameras_found: "cameras found",
    status_camera_location: "Location",
    status_camera_not_specified: "Not specified",
    status_camera_firmware: "Firmware",
    status_camera_firmware_current: "current",
    status_camera_firmware_outdated: "outdated",
    audit_title: "Audit Logs",
    audit_subtitle: "Verkada Audit Logs and Activity Records",
    audit_time_range: "Time Range",
    audit_last_24h: "Last 24 Hours", 
    audit_last_7d: "Last 7 Days",
    audit_last_30d: "Last 30 Days",
    audit_custom: "Custom",
    audit_loading: "Loading Audit Logs...",
    audit_error: "Error loading Audit Logs",
    audit_no_data: "No Audit Logs found in selected time range",
    audit_refresh: "Refresh",
    audit_page_size: "Entries per page",
    audit_timestamp: "Timestamp",
    audit_action: "Action",
    audit_user: "User",
    audit_details: "Details",
    audit_event: "Event",
    audit_device: "Device",
    audit_ip_address: "IP Address",
    audit_no_actions: "No actions",
    audit_no_payload: "No payload data",
    audit_hours_ago: "{h}h ago",
    audit_logs: "Audit Logs", 
    audit_custom_days: "Custom ({} Days)",
    audit_days_slider: "Days: {} (max 30)",
    audit_day: "day",
    audit_days: "days",
    audit_time_range_label: "Time range",
    audit_slider_hint: "Drag the slider and release to load Audit Logs",
    audit_select_all: "Select All",
    audit_selected_count: "{} selected",
    audit_bulk_actions: "Bulk Actions",
    audit_export_selected: "Export Selected",
    audit_clear_selection: "Clear Selection",
    entries: "entries",
    tabs_help: "Help",
    show_password: "show",
    hide_password: "hide",
    show_details: "Show details",
    fields: "fields",
    data_loading: "Loading data...",
    load_statistics: "Load statistics",
    click_load_sightings: "Click on \"Load sightings\"",
    click_delta_calculate: "Click on \"Calculate Delta\" to start",
    click_refresh_audit: "Click on \"Refresh\" to load Audit Logs",
    all_systems_ready: "All systems operational",
    no_cameras_loaded: "No cameras loaded",
    login_user_title: "Email (User)",
    login_password: "Password",
    login_user_btn: "User/Tenant Login",
    api_key_available: "API-Key available",
    api_key_missing: "API-Key missing",
    more_available: "more available",
    login_hint: "Login with email/password. LPR is only available for User/Tenant.",
    login_please_wait: "Please wait…",
    login_admin_toggle_show: "Show Admin Login",
    login_admin_toggle_hide: "Hide Admin Login",
    login_admin_email: "Admin Email",
    login_admin_btn: "Admin Login",
    date_pick: "Select Date",
    date_pick_hint: "Select a date",
    date_selected: "Selected:",
    configuration: "Configuration",
    configuration_hint: "Set parameters for analysis",
    threshold: "Threshold (0–48 hrs.)",
    gap: "Dedup Gap (0–30 min.)",
    camera_ids: "Camera Device IDs",
    plate_filter: "License Plate Filter",
    delta_calc: "Calculate Delta",
    csv_download: "CSV Download",
    user_settings: "User Settings",
    settings_title: "User Settings",
    settings_saved: "Saved",
    settings_cameras_title: "Camera IDs",
    x_api_key_new: "New x-api-key (optional, will be saved)",
    x_api_key_saved_note: "An API key is saved. Inserting a new one will overwrite it.",
    org_id: "Org ID",
    org_id_placeholder: "e.g. ac6b3acd-347d-4fc7-bc91-...",
    org_id_saved: "Saved:",
    region: "Region (us | eu | au)",
    timezone: "Timezone",
    camera_replace: "Camera IDs (replace saved list)",
    positives_title: "Positive License Plates (ignored in delta)",
    positives_add: "Add",
    positives_delete: "Remove",
    settings_save: "Save settings",
    delta_pairs: "Delta pairs",
    sightings: "Raw sightings",
    load_sightings: "Load sightings",
    loading: "Loading...",
    sightings_csv: "Raw CSV",
    entries: "entries",
    vip_plates: "VIP plates",
    vip_plates_highlighted: "VIP plates highlighted",
    plate_placeholder: "e.g. PAMX",
    plate_input_placeholder: "License plate (e.g. ABC123)",
    loading_webhook_config: "Loading webhook configuration...",
    webhook_token_placeholder: "e.g. my-verkada-hook-2024",
    item_placeholder: "e.g. Coffee, Sandwich, etc.",
    hint_admin_no_lpr: "Note: Admin cannot perform LPR queries; user management only.",
    hint_select_entries: "Tip: Select entries to export them",
    export_entries: "Export entries",
    please_select_entries: "Please select entries first",
    load_more_entries: "Load more entries",
    th_plate: "Plate",
    th_entry: "Entry",
    th_exit: "Exit",
    th_dur_min: "Duration (min)",
    th_dur_h: "Duration (h)",
    th_cam_entry: "Entry cam",
    th_cam_exit: "Exit cam",
    th_image: "Image",
    empty_delta: "No delta data for filters/date. Adjust parameters.",
    empty_sight: "No raw sightings loaded yet.",
    help_title: "Help & legend",
    help_text: "Green: below threshold · Yellow: near threshold · Red: well above. Gap: merges sightings close in time.",
    help_login_title: "🔐 Login & User Roles",
    help_login_text: "• User/Tenant Login: Full access to LPR analysis and settings\n• Admin Login: User management only, no LPR access\n• One user per tenant can log in",
    help_analysis_title: "📊 LPR Analysis",
    help_analysis_sightings: "🔍 Sightings (Raw Data):\n• All license plate detections for a day\n• Filters: License plate search, camera selection\n• Red marking: VIP license plates\n• 📊 Automatic hourly statistics after loading",
    help_analysis_delta: "⏱️ Delta Analysis:\n• Shows duration of license plate stays\n• Threshold: Minimum stay duration in hours\n• Gap: Merges nearby sightings\n• Color code: Green (short) → Yellow → Red (long)",
    help_sightings_chart_title: "📊 Sightings per Hour",
    help_sightings_chart_text: "Automatically displays a chart showing vehicle detection distribution across 24 hours:\n• Auto-loads after raw sightings\n• Bar chart: Number of sightings per hour\n• Date format: DD-MM-YY\n• Interactive tooltips with details",
    help_status_title: "📈 Status Dashboard",
    help_status_system: "🟢 System Online: Shows current status of all services\n📡 Verkada API: Connection status to Verkada platform\n📹 Camera Overview: Live thumbnails and details of all cameras",
    help_status_cameras: "Camera Functions:\n• Automatic loading when accessing dashboard\n• Live thumbnails from each camera\n• Status display: Live (green) / Offline (red)\n• Firmware status: 🟢 current / 🔴 outdated\n• Detailed information: Location, IP, Serial, Features",
    help_audit_title: "🔍 Audit Logs",
    help_audit_overview: "Monitor all system activities and user actions in real-time:",
    help_audit_timerange: "⏰ Time Range Selection:\n• 24h, 7d, 30d - Predefined ranges\n• Custom: Slider for 1-30 days\n• Drag and release to load",
    help_audit_table: "📊 Table Functions:\n• Sorting: Click column header\n• 🏷️ Sort by Type: Group by event type\n• Checkboxes: Multi-select for export\n• Hover effects: Enhanced navigation",
    help_audit_columns: "📋 Column Details:\n• Timestamp: German format with 'ago Xh'\n• User: 👤 Badges with name/email\n• Event: Event description + IP address\n• Device: 🔧 Device name + 📍 Site info",
    help_audit_actions: "⚡ Actions:\n• CSV Export: Export selected entries\n• Clear Selection: Reset selection\n• Live updates with refresh button",
    help_settings_title: "⚙️ Settings",
    help_settings_user: "👤 User Settings:\n• API Key: Verkada access\n• Cameras: Selection of monitored cameras\n• Region & Timezone: Verkada server settings",
    help_settings_positive: "✅ Positive License Plates:\n• 'Whitelist' - hidden from delta analysis\n• Input: Single or multiple (comma/line separated)",
    help_vip_title: "🔴 VIP License Plates (LPOI)",
    help_vip_text: "VIP license plates are marked RED in raw data and tagged with 🔴.",
    help_vip_types: "🔗 Verkada LPOI: Stored and synchronized in Verkada\n📍 Local: Stored only in this application",
    help_vip_functions: "• Add Local: Saves VIP only in the app\n• Create Verkada: Creates LPOI directly in Verkada\n• Verkada Sync: Fetches all LPOIs from Verkada\n• Delete: Removes VIP (also from Verkada if sourced there)",
    help_admin_title: "👥 Admin Functions",
    help_admin_text: "• Create User: Email, password, assign role\n• Delete User: Remove existing users\n• Role 'user': LPR access + settings\n• Role 'admin': User management only",
    help_ai_analytics_title: "🧠 AI Analytics",
    help_ai_analytics_intro: "Analyze camera images with AI (Google Gemini) and automatically create Helix events in Verkada.",
    help_ai_analytics_setup: "1. Setup:",
    help_ai_analytics_setup_desc: "• Gemini API Key: Enter your Google AI API key in settings\n• Camera ID: Verkada camera ID for fetching images\n• HELIX UID: Event type ID from Verkada for Helix integration\n• Org ID: Your Verkada organization ID (global setting)",
    help_ai_analytics_usage: "2. Usage:",
    help_ai_analytics_usage_desc: "• 'Get Latest Image': Load current image from configured camera\n• 'Manual Upload': Upload your own image (max 1024px, auto-compressed)\n• Enter instruction: Question for the AI (max 200 chars)\n• 'Analyze': AI analyzes image and returns true/false/unknown",
    help_ai_analytics_helix: "3. Helix Integration:",
    help_ai_analytics_helix_desc: "• For API images, a Helix event is automatically created\n• Event contains: Result (true/false), question, timestamp\n• Flagged status: true for positive results\n• Only with configured HELIX UID and Org ID",
    help_ai_analytics_history: "4. History:",
    help_ai_analytics_history_desc: "• Last 25 analyses are displayed in a table\n• Contains: Timestamp, thumbnail, instruction, result\n• Data is stored per user",
    help_tips_title: "💡 Tips & Tricks",
    help_tips_text: "• Select date for analysis\n• Gap minutes: Reduces multiple detections\n• Open sessions: Vehicles without exit\n• Use VIP for important/suspicious license plates\n• 📊 Hourly chart shows traffic patterns automatically\n• Chart loads automatically after raw sightings",
    admin_console: "Admin console: user management",
    admin_new_user: "Create user – email",
    admin_password: "Password",
    admin_role: "Role",
    admin_create: "Create user",
    admin_refresh: "Refresh list",
    admin_users_title: "Users",
    admin_search: "Search",
    admin_pw_reset: "Reset PW",
    admin_delete: "Delete",
    admin_delete_field: "Delete user – email",
    admin_delete_btn: "Delete user",
    confirm_delete_user: "Really delete user?",
    confirm_delete_plates: "Really remove positive plates?",
    
    // Cash Register System
    kasse_title: "Cash Register",
    kasse_subtitle: "Point-of-Sale System for sales processing",
    kasse_add_item: "Add Item",
    kasse_item_name: "Item Name",
    kasse_item_price: "Price (€)",
    kasse_item_quantity: "Quantity",
    kasse_add_to_cart: "Add Item",
    kasse_quick_add: "Quick Add",
    kasse_customer_name: "Customer (optional)",
    kasse_total_amount: "Total Amount",
    kasse_complete_payment: "Complete Payment",
    kasse_process_return: "Process Return",
    kasse_clear_cart: "Clear Receipt",
    kasse_cart: "Shopping Cart",
    kasse_empty_cart: "No items added yet",
    kasse_empty_cart_desc: "Add items above to get started",
    kasse_item_article: "Article",
    kasse_item_quantity_short: "Quantity",
    kasse_item_unit_price: "Unit Price",
    kasse_item_total_price: "Total",
    kasse_action: "Action",
    
    // Cash Register History
    kasse_history_title: "Transaction History",
    kasse_history_subtitle: "Last 50 cash register transactions",
    kasse_search_placeholder: "🔍 Search by Customer or Item...",
    kasse_search_no_results: "No results found",
    kasse_table_datetime: "Date & Time",
    kasse_table_items: "Items",
    kasse_table_customer: "Customer",
    kasse_table_thumbnail: "Camera Snapshot",
    kasse_table_empty: "No transactions yet",
    
    // Receipt Modal
    receipt_title: "Receipt",
    receipt_store_name: "Helix Cafe Shop",
    receipt_store_address: "Industriestraße 42, 10115 Berlin",
    receipt_date: "Date",
    receipt_time: "Time",
    receipt_receipt_no: "Receipt No",
    receipt_customer: "Customer",
    receipt_items_title: "Items",
    receipt_quantity: "Qty",
    receipt_price_each: "Price Each",
    receipt_price_total: "Total",
    receipt_subtotal: "Subtotal",
    receipt_tax: "incl. VAT (19%)",
    receipt_total: "TOTAL",
    receipt_payment_method: "Payment Method",
    receipt_payment_cash: "Cash",
    receipt_thank_you: "Thank you for your purchase!",
    receipt_return: "RETURN",
    receipt_refund: "Refund",
    receipt_snapshot: "Camera Snapshot",
    
    // Cash Register System Help
    help_kasse_title: "💰 Cash Register System",
    help_kasse_intro: "Point-of-Sale System with Verkada integration for sales and returns.",
    help_kasse_add_items: "🛒 Adding Items:",
    help_kasse_add_items_desc: "• Quick Add: ☕ Coffee (€3.00), 🥪 Sandwich (€5.00), 🥤 Drink (€2.00)\n• Manual: Enter name, price, quantity",
    help_kasse_transactions: "💳 Sales & ↩️ Returns:",
    help_kasse_transactions_desc: "• \"Complete Payment\" → Verkada Event (flagged: false)\n• \"Process Return\" → Verkada Event (flagged: true)\n• Automatic Berlin time and video tagging",
    help_kasse_settings: "⚙️ Required Settings:",
    help_kasse_settings_desc: "• UID (Verkada Helix) + Cash Register Camera ID\n• API key with Video Tagging permissions",
    
    help_shipping_title: "📦 Shipping Label System",
    help_shipping_intro: "Automated shipping label system with Verkada integration for package tracking and camera snapshots.",
    help_shipping_label: "🏷️ Creating Labels:",
    help_shipping_label_desc: "• Tracking Number: Auto-generated when opening module\n• 🌍 Generate Address: 41 international fake addresses\n• 📦 Generate Content: 50 electronic devices (1-5 random)\n• Shipping Address: Enter complete delivery address\n• Package Content: Brief description of contents\n• UPS-style label with all details",
    help_shipping_workflow: "📋 Workflow:",
    help_shipping_workflow_desc: "• Open module → Tracking number generated\n• Enter address & contents (or generate)\n• \"Generate Label\" → Verkada event sent\n• After 3 seconds: Camera thumbnail automatically retrieved\n• On success: New tracking number for next label\n• On error: Data remains for retry",
    help_shipping_verkada: "🔗 Verkada Integration:",
    help_shipping_verkada_desc: "• Sends event with attributes: Tracking, Address, Position\n• Video tagging with configurable camera\n• Automatic time recording (Epoch timestamp)\n• Thumbnail retrieved 3 sec after event (low-res)\n• Success confirmation or error message",
    help_shipping_settings: "⚙️ Required Settings:",
    help_shipping_settings_desc: "• UID (Verkada Helix) for shipping module\n• Camera ID for shipping area (for thumbnails)\n• API key with Video Tagging & View Footage permissions\n• Region: EU or US server",
    help_shipping_features: "✨ Features:",
    help_shipping_features_desc: "• Automatic tracking numbers (1Z + 16 characters)\n• UPS-compatible label design\n• 📸 Camera thumbnails (clickable for fullscreen)\n• Text truncation to max 200 characters per field\n• Success/error messages like cash register module\n• Fields automatically cleared after success",
    help_shipping_history: "📋 Shipping History:",
    help_shipping_history_desc: "• Shows last 50 created labels\n• 🔍 Searchable: Tracking ID, Address, Content\n• ↕️ Sortable: By Date, Tracking, Address, Content\n• Columns: Date/Time, Tracking ID, Address, Content, Thumbnail\n• Thumbnails clickable for enlarged view",
    
    // Automation Help
    help_automation_title: "Automation",
    help_automation_intro: "Control your Shelly devices directly from the dashboard.",
    help_automation_setup: "⚙️ Setup:",
    help_automation_setup_desc: "1. Go to Settings → Shelly\n2. Enter your Shelly Server (e.g. https://shelly-XX-eu.shelly.cloud)\n3. Add your Auth Key from the Shelly Cloud App\n4. Enter your device IDs and names",
    help_automation_control: "🎮 Control:",
    help_automation_control_desc: "• On/Off buttons for direct switching\n• Status is automatically fetched on open\n• Refresh button for manual update\n• Power consumption displayed (if supported)",
    help_automation_status: "📊 Status Display:",
    help_automation_status_desc: "The colored dot shows the current device status.",
    help_automation_colors: "Color Legend:",
    help_automation_color_on: "Switched On",
    help_automation_color_off: "Switched Off",
    help_automation_color_offline: "Offline",
    help_automation_color_loading: "Loading...",
    
    // Menu Dropdown
    menu_webhooks: "Webhooks",
    menu_shipping: "Shipping",
    menu_cash_register: "Cash Register",
    
    // Dashboard Modules
    dashboard_title: "🏠 Helix Control Center",
    dashboard_welcome: "Welcome back",
    dashboard_time_suffix: "",
    dashboard_module_lpr_title: "LPR Analytics",
    dashboard_module_lpr_desc: "License Plate Recognition\nReal-time Analysis & Monitoring",
    dashboard_module_lpr_btn: "📊 Start Analysis",
    dashboard_module_status_title: "Status Dashboard",
    dashboard_module_status_desc: "System Monitoring\nLive Status & Health Check", 
    dashboard_module_status_btn: "📈 Check Status",
    dashboard_module_audit_title: "Audit Dashboard",
    dashboard_module_audit_desc: "Security & Activity Logs\nView, Search & Export",
    dashboard_module_audit_btn: "🔍 Open Audit",
    dashboard_module_kasse_title: "Cash Register",
    dashboard_module_kasse_desc: "Point of Sale System\nVerkada Integration & Events",
    dashboard_module_kasse_btn: "💰 Open Register",
    dashboard_module_settings_title: "Settings",
    dashboard_module_settings_desc: "Configuration & Setup\nAPI Keys, Cameras & VIPs",
    dashboard_module_settings_btn: "⚙️ Configuration",
    dashboard_module_webhook_title: "Webhook System",
    dashboard_module_webhook_desc: "Real-time Events\nVerkada Integration & Automation",
    dashboard_module_webhook_btn: "🔗 Open Webhooks",
    dashboard_module_shipping_title: "Shipping Label System",
    dashboard_module_shipping_desc: "Shipping Label Management\nVerkada Integration & Package Tracking",
    dashboard_module_shipping_btn: "📦 Open Shipping Labels",
    dashboard_module_support_title: "AI Support",
    dashboard_module_support_subtitle: "Help and Assistance",
    dashboard_module_support_desc: "",
    dashboard_module_support_btn: "🎧 Open Support",
    
    // Automation Module
    menu_automation: "Automation",
    automation_title: "Automation",
    automation_subtitle: "Manage devices & automations",
    automation_not_configured: "Shelly not configured",
    automation_not_configured_hint: "Please configure your Shelly devices in Settings.",
    automation_no_devices: "No devices configured",
    automation_no_devices_hint: "Add Shelly devices in Settings.",
    automation_device: "Device",
    automation_device_single: "Device",
    automation_device_plural: "Devices",
    automation_on: "On",
    automation_off: "Off",
    automation_connected: "Connected",
    automation_not_connected: "Not configured",
    automation_offline: "Offline",
    automation_loading: "Loading...",
    automation_refresh: "Refresh",
    automation_rules_title: "Automations",
    automation_rules_new: "New",
    automation_rules_coming_soon: "Automations will be available in a future update.",
    automation_rules_example: "e.g. \"When license plate detected → Turn on light\"",
    automation_lpr_shelly_title: "Turn on Shelly switch 1 on LPR",
    automation_lpr_shelly_desc: "When webhook \"door_lp_presented_accepted\" is received: first Shelly switch turns ON for 10 seconds, then OFF automatically.",
    automation_lpr_rejected_shelly_title: "Turn on Shelly switch 2 on LPR rejected",
    automation_lpr_rejected_shelly_desc: "When webhook \"door_lp_presented_rejected\" is received: second Shelly switch turns ON for 10 seconds, then OFF automatically.",
    automation_lpr_shelly_warning: "Note: Shelly Server, Auth Key, and at least 1 device must be configured under Settings for this rule to take effect.",
    automation_missing_device: "Switch {n} missing – please configure under Settings.",
    automation_disarmed_call_title: "Phone call when alarm is disarmed",
    automation_disarmed_call_desc: "When webhook \"disarmed\" is received: configured phone number is called and the text is read out in the selected language (Twilio Voice).",
    automation_armed_call_title: "Phone call when alarm is armed",
    automation_armed_call_desc: "When webhook \"alarm_site_state_changed\" with event_type=\"armed\" is received: configured phone number is called and the text is read out in the selected language.",
    automation_armed_call_text_placeholder: "e.g. Attention, the alarm has just been armed.",
    automation_disarmed_call_to_label: "Phone number (E.164)",
    automation_disarmed_call_lang_label: "Language",
    automation_disarmed_call_text_label: "Text to read",
    automation_disarmed_call_text_placeholder: "e.g. Attention, the alarm has just been disarmed.",
    automation_call_test_btn: "Test call",
    automation_call_test_missing: "Please enter phone number and text.",
    automation_call_test_ok: "✅ Test call successfully triggered",
    automation_call_test_fail: "❌ Test call failed",
    automation_twilio_missing: "Twilio Account SID, Auth Token and From number must be configured under Settings.",
    settings_twilio_title: "Twilio Voice",
    settings_twilio_subtitle: "Credentials for outbound voice calls (TTS).",
    settings_twilio_from_number: "twilioPhoneNumber (outbound number)",
    settings_twilio_from_hint: "Twilio number in E.164 format, e.g. +1234567890",
    settings_saved_short: "saved",
    dashboard_module_automation_title: "Automation",
    dashboard_module_automation_desc: "Control devices\n& automate",
    dashboard_module_automation_btn: "⚡ Open",
    
    // AI Analytics Module
    dashboard_module_ai_analytics_title: "AI Analytics",
    dashboard_module_ai_analytics_subtitle: "Image Analysis with AI",
    dashboard_module_ai_analytics_btn: "Open AI Analytics",
    ai_analytics_title: "AI Analytics",
    ai_analytics_subtitle: "Intelligent Image Analysis",
    ai_analytics_get_last_image: "Get Last Image",
    ai_analytics_manual_upload: "Manual Upload",
    ai_analytics_instruction: "Instruction Yes/No Answer",
    ai_analytics_instruction_placeholder: "Enter your instruction for AI analysis here...",
    ai_analytics_result: "Result",
    ai_analytics_result_placeholder: "The analysis result will appear here...",
    ai_analytics_image_preview: "Image Preview",
    ai_auto_refresh_label: "Auto-refresh enabled",
    ai_auto_refresh_minutes_unit: "min",
    ai_auto_refresh_preset_label: "Predefined analysis (Auto-Refresh)",
    ai_auto_refresh_preset_none: "No analysis",
    ai_auto_refresh_preset_hint: "If auto-refresh is on and an analysis is selected: every X minutes a new image is fetched + analyzed.",
    ai_preset_cat: "Is there a cat?",
    ai_preset_tree: "Is there a tree?",
    ai_preset_snow: "Is there snow?",
    ai_preset_sun: "Is the sun shining?",
    ai_analytics_no_image: "No image loaded",
    ai_analytics_analyze: "Analyze",
    ai_analytics_analyzing: "Analyzing...",
    ai_analytics_history_title: "Transaction History (last 25)",
    ai_analytics_history_datetime: "Date & Time",
    ai_analytics_history_image: "Image",
    ai_analytics_history_instruction: "Instruction",
    ai_analytics_history_result: "Result",
    ai_analytics_history_empty: "No transactions yet",
    
    // AI Analytics Settings
    ai_analytics_settings_title: "AI Analytics Settings",
    ai_analytics_camera_id: "Camera ID",
    ai_analytics_camera_id_placeholder: "e.g. camera-123-abc",
    ai_analytics_camera_id_saved: "Saved:",
    ai_analytics_gemini_key: "Gemini API-Key",
    ai_analytics_gemini_key_placeholder: "Enter your Gemini API-Key",
    ai_analytics_gemini_key_saved: "✓ API-Key saved",
    ai_analytics_helix_uid: "HELIX UID",
    ai_analytics_helix_uid_placeholder: "e.g. helix-uid-123",
    ai_analytics_helix_uid_saved: "Saved:",
    ai_analytics_org_id: "Org ID",
    ai_analytics_org_id_placeholder: "e.g. ac6b3acd-347d-4fc7-bc91-...",
    ai_analytics_org_id_saved: "Saved:",
    ai_analytics_save: "Save AI Analytics",
    ai_analytics_saved_success: "AI Analytics settings saved",
    
    // Support Module
    support_title: "Support Center",
    support_subtitle: "Help & Assistance",
    support_enabled: "Support module enabled",
    support_contact_title: "Contact",
    support_contact_desc: "For questions or issues, please contact our support team.",
    support_email: "Email",
    support_phone: "Phone",
    support_hours: "Availability",
    support_hours_value: "Mon-Fri 9:00 AM - 5:00 PM",
    support_faq_title: "FAQ",
    support_docs_title: "Documentation",
    support_docs_desc: "Guides and help articles",
    
    // Admin - Support checkbox
    admin_support_enabled: "Support Module",
    
    // Help - Workflow Recommendation
    help_workflow_title: "📋 Workflow Recommendation:",
    help_workflow_steps: "1. Configure settings (API keys, cameras)\n2. Define positive plates (known vehicles)\n3. Set VIP plates (wanted/surveillance)\n4. Configure cash register system (UID + Camera ID)\n5. Configure shipping label system (UID + Camera ID)\n6. Daily delta analysis for anomalies\n7. Check raw data for specific suspicious cases",
    
    // Webhook System
    webhook_title: "Webhook Management",
    webhook_subtitle: "Verkada Webhooks for Real-time Events",
    webhook_url_label: "Your Webhook URL:",
    webhook_url_copy: "Copy URL",
    webhook_url_copied: "URL copied!",
    webhook_enabled: "Webhook enabled",
    webhook_disabled: "Webhook disabled",
    webhook_toggle: "Enable/disable webhook",
    webhook_stats_title: "Webhook Statistics",
    webhook_stats_total: "Total Events",
    webhook_stats_today: "Events Today",
    webhook_stats_last: "Last Event",
    webhook_auto_actions: "Automatic Actions",
    webhook_auto_vip: "Auto-VIP on Person of Interest",
    webhook_events_title: "Event History",
    webhook_events_type: "Event Type",
    webhook_events_time: "Timestamp",
    webhook_events_notification_type: "Notification Type",
    webhook_events_actions: "Actions Triggered",
    webhook_events_payload: "Payload",
    webhook_events_refresh: "Refresh Events",
    webhook_events_empty: "No webhook events found",
    webhook_notifications_title: "Live Notifications", 
    webhook_notification_new: "New Webhook Event",
    webhook_create_token: "Configure Webhook Token",
    webhook_create_description: "Create a unique token for your webhook URL. This token identifies all incoming webhooks as belonging to your account.",
    webhook_token_label: "Webhook Token (minimum 6 characters):",
    webhook_token_placeholder: "e.g. my-verkada-hook-2024",
    webhook_create_btn: "Create",
    webhook_creating: "Creating...",
    
    // Shipping System
    shipping_title: "Shipping Label System", 
    shipping_subtitle: "Shipping Label Management - Verkada Integration",
    shipping_uid_label: "Shipping UID",
    shipping_uid_placeholder: "Enter Verkada Helix Endpoint UID",
    shipping_uid_placeholder_saved: "(saved) – enter new UID to change",
    shipping_camera_label: "Shipping Camera ID",
    shipping_camera_placeholder: "Verkada Camera ID for shipping area",
    shipping_camera_placeholder_saved: "(saved) – enter new ID to change",
    shipping_settings_help: "UID: Unique Verkada Helix Endpoint for shipping\nCamera ID: Verkada Camera ID for monitoring the shipping area",
    shipping_address_label: "Shipping Address",
    shipping_content_label: "Package Content",
    shipping_address_placeholder: "John Doe\n123 Main Street\nNew York, NY 10001\nUSA",
    shipping_content_placeholder: "Describe package contents...",
    shipping_generate_btn: "📦 Generate Label",
    shipping_create_section: "📋 Create Shipping Label",
    shipping_preview_section: "📦 Shipping Label Preview",
    shipping_generate_address_btn: "🌍 Generate Address",
    shipping_generate_content_btn: "📦 Generate Content",
    shipping_history_title: "Shipping History",
    shipping_history_subtitle: "Last 50 created shipping labels",
    shipping_search_placeholder: "🔍 Search by Tracking ID, Address or Content...",
    shipping_search_no_results: "No results found",
    shipping_table_datetime: "Date & Time",
    shipping_table_tracking: "Tracking ID",
    shipping_table_address: "Shipping Address",
    shipping_table_content: "Package Content",
    shipping_table_thumbnail: "Camera Snapshot",
    shipping_table_empty: "No shipping labels created yet",
    
    // Email Modal
    email_subject: "📧 Shipment of Your Order",
    email_from: "From",
    email_to: "To",
    email_date: "Date",
    email_greeting: "Hello",
    email_body_text: "your ordered items",
    email_body_tracking: "have been shipped with tracking no.",
    email_body_shipped: "just now.",
    email_thumbnail_caption: "📸 Photo at time of shipment",
    email_closing: "Best regards and enjoy!",
    email_footer_company: "Helix Shop GmbH",
    email_footer_address_line1: "Industriestraße 42",
    email_footer_address_line2: "10115 Berlin, Germany",
    email_footer_disclaimer: "This email was generated automatically. Please do not reply directly.",

    // Settings - Shelly / VIP / Kasse (hardcoded → i18n)
    settings_vip_plates_title: "VIP Plates (Verkada LPOI)",
    settings_vip_plates_add: "Add VIP Plate",
    settings_vip_plates_local_only: "Stored in this application only",
    settings_vip_delete_confirm: "Really delete VIP plate \"{plate}\"?",
    settings_kasse_not_configured: "⚠️ POS integration not yet configured",
    settings_kasse_camera_id: "Camera ID POS",
    settings_kasse_endpoint_desc: "Unique Verkada Helix endpoint for POS",
    settings_camera_id_label: "Camera ID:",
    settings_shelly_server_label: "Shelly Server",
    settings_shelly_server_hint: "Format: shelly-XX-eu.shelly.cloud (from Shelly App → User Settings → Authorization Cloud Key)",
    settings_shelly_device_id_placeholder: "Device ID (hex), e.g. 34987a6b1234",
    settings_shelly_device_name_placeholder: "e.g. Office Light",
    settings_shelly_authkey_label: "Auth Key",
    settings_shelly_authkey_saved: "✓ Auth Key saved",
    settings_shelly_devices_title: "Shelly Devices",
    settings_shelly_no_devices: "No devices yet.",
    settings_shelly_remove_saved: "Remove device (takes effect after Save)",
    settings_shelly_remove_entry: "Remove entry",
    settings_shelly_add_device: "+ Add device",
    settings_shelly_hint: "Enter device ID and name, then click \"Save\" below. Changes (add, edit, delete) take effect only after saving.",
    settings_saved_alert: "User settings saved.",
    settings_no_changes_alert: "No changes",

    // App.js hardcoded
    app_user_label: "User:",
    app_please_login: "Please log in",
    app_no_users: "No users found.",

    // Help / Webhooks hardcoded labels
    help_vip_types_label: "VIP types:",
    webhooks_integration_label: "💡 Webhook integration:",

    // Live View (Settings)
    settings_liveview_title: "Live View",
    settings_liveview_subtitle: "Verkada live-view iFrames for camera display.",
    settings_liveview_entry_prefix: "Liveview",
    settings_liveview_name_label: "Name",
    settings_liveview_name_placeholder: "e.g. Garden Camera",
    settings_liveview_embed_label: "Embedded code",
    settings_liveview_embed_placeholder: "<iframe src=\"https://vauth.prod2.verkada.com/__v/…/embed/html/…/\" frameborder=\"0\" width=\"400\" height=\"300\"></iframe>",
    settings_liveview_no_entries: "No live views configured yet.",
    settings_liveview_add: "+ add another live view",
    settings_liveview_remove_entry: "Remove entry",
    settings_liveview_remove_saved: "Remove live view (takes effect after Save)",
    settings_liveview_hint: "Enter name and embedded code, then click \"Save\" below. Changes (add, edit, delete) only take effect after \"Save\". Entries with an empty Name OR an empty Embedded code are dropped on save.",

    // Live View (Page + Menu + Dashboard tile)
    menu_live_view: "Live View",
    dashboard_module_live_view_title: "Live View",
    dashboard_module_live_view_desc: "Watch cameras live\niFrame tiles from Settings",
    dashboard_module_live_view_btn: "📺 Open",
    live_view_title: "Live View",
    live_view_subtitle: "Cameras from Settings",
    live_view_enlarge: "Enlarge",
    live_view_reload: "Reload",
    live_view_close: "Close",
    live_view_empty_title: "No live views configured yet.",
    live_view_empty_hint: "Open Settings → Live View to add your first camera.",
    live_view_empty_cta: "Go to Settings",
  }
};

const useI18n = () => {
  const [lang, setLang] = useState('de');
  
  const t = (key) => {
    return dict[lang][key] || key;
  };

  return { t, lang, setLang };
};

export { useI18n };